<template>
  <div
    class="modal api-key-revoke-modal"
    :class="{ 'is-active': isActive }"
    @keyup.esc="$emit('close-modal')"
  >
    <div class="modal-background"></div>
    <div class="modal-card">
      <header class="modal-card-head">
        <p class="modal-card-title">
          {{ $t('api_keys.modal.revocation_title') }}
        </p>
        <button class="delete" aria-label="close" @click="$emit('close-modal')">
          <i class="mdi mdi-close"></i>
        </button>
      </header>
      <section class="modal-card-body">
        <p>
          {{ $t('api_keys.modal.revocation_warning') }}
          <span class="has-text-weight-semibold">{{
            $t('api_keys.modal.irreversible_action')
          }}</span>
        </p>
        <div class="input-container">
          <input
            type="text"
            class="input is-shadowless"
            v-model="text"
            autofocus
            :placeholder="$t('api_keys.modal.confirmation_text')"
            @keyup.enter="onConfirmation()"
          />
        </div>
      </section>
      <footer class="modal-card-foot">
        <button class="button cancel-button" @click="$emit('close-modal')">
          {{ $t('api_keys.info.cancel') }}
        </button>
        <button
          class="button revoke-btn"
          @click="onConfirmation()"
          :disabled="isLoading || text.toUpperCase() !== 'REVOKE'"
        >
          {{ $t('api_keys.info.confirm') }}
        </button>
      </footer>
    </div>
  </div>
</template>

<script>
import store from 'store';
import { mapState, mapGetters } from 'vuex';
import { pick } from 'lodash';

import Api from 'services/Api';
import i18n from 'services/i18n';
import notifications from 'services/Notifications';

const { keys, values } = Object;

export default {
  name: 'KeyRevokeModal',
  props: {
    isActive: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    ...mapState('api_key', ['keyToRevoke']),
  },

  components: {},
  data() {
    return {
      isLoading: false,
      text: '',
    };
  },

  methods: {
    async onConfirmation() {
      if (this.isLoading || this.text.toUpperCase() !== 'REVOKE') {
        return;
      }

      await this.revokeKey();
    },

    async revokeKey() {
      try {
        this.isLoading = true;
        await store.dispatch('api_key/revokeKey', this.keyToRevoke.id);

        this.$emit('close-modal');
        this.$emit('reload');
      } catch (error) {
        console.log(error);

        const message = error.body && error.body.message;
        notifications.add(
          message || this.$t('api_keys.errors.revoke_key_failed')
        );
      } finally {
        this.text = '';
        this.isLoading = false;
      }
    },
  },
};
</script>
<style scoped lang="scss">
.modal-card-foot {
  justify-content: center;

  .cancel-button {
    margin: 0;
  }
}
</style>
